<template>
  <div class="settingWrapper">
    <div class="setting flex-row flex-even">
      <p class="part-name">
        <span>{{ $t('SAAI.Report.totalStudentNumber') }} : </span>
        {{ numberOfStudents }}
      </p>
      <p class="part-name">
        <span>{{ $t('SAAI.Report.totalQuestionNumber') }} : </span>
        {{ numberOfQuestions }}
      </p>
      <div class="flex-row flex-center">
        <p class="part-name">
          <span>{{ $t('SAAI.Report.reportName') }} : </span>
        </p>
        <input type="text" name="paperName" @input="(event) => setPaperTitle(event.target.value)" />
      </div>
    </div>
    <TabulatorComponent v-model="studentObject" :options="options" />
  </div>
</template>
<script>
import { TabulatorComponent } from 'vue-tabulator';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'FileSetting',
  components: {
    TabulatorComponent,
  },
  data() {
    return {
      timer: null,
      answerTableData: [],
      tableHeader: [],
      options: {
        columns: [],
      },
      data: [],
    };
  },
  methods: {
    ...mapActions('saaiReport', ['AC_SET_PAPER_TITLE', 'AC_SET_STUDENT_OBJECT']),
    setPaperTitle(value) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.AC_SET_PAPER_TITLE(value);
      }, 200);
    },
    setStudentsData() {
      const originHeader = this.studentList[0].map((str) => str.trim().replace(/\s/g, ''));
      const headerData = ['id', '반', '번호', '이름'];
      if (originHeader.length >= 4) {
        headerData.push(...originHeader.slice(4));
      }
      this.tableHeader = headerData;

      const rawStudentData = [...this.studentList.slice(1)];
      const studentObjects = rawStudentData.slice(0).map((studentData) => {
        const studentObject = {};
        for (let i = 0; i < headerData.length; i++) {
          studentObject[headerData[i]] = studentData[i];
        }
        return studentObject;
      });

      this.AC_SET_STUDENT_OBJECT(studentObjects.sort((a, b) => a.id - b.id));
    },
    setTableHeader() {
      const headerData = this.tableHeader;
      const width = 100 / headerData.length + '%';

      const transformedHeader = headerData.map((item) => ({
        title: item,
        field: item,
        width: `${width}`,
        editor: false,
        headerSort: false,
      }));

      this.options.columns = transformedHeader;
    },
  },
  computed: {
    ...mapState('saaiReport', {
      originData: (state) => state.originData,
      numberOfStudents: (state) => state.numberOfStudents,
      numberOfQuestions: (state) => state.numberOfQuestions,
      studentList: (state) => state.studentList,
      studentObject: (state) => state.studentObject,
    }),
  },
  created() {
    this.setStudentsData();
    this.setTableHeader();
  },
};
</script>
<style lang="scss" scoped>
.settingWrapper {
  .setting {
    margin: 15px 0;
    padding: 10px 0;
    border: 2px solid $MAIN-COLOR;
    border-radius: 10px;
    input {
      border-radius: 5px;
      padding: 5px 10px;
      font-size: 1rem;
    }
  }
  .question {
    margin: 15px 0;
    padding: 10px;
    border: 2px solid $MAIN-COLOR;
    border-radius: 10px;
  }
}
.part-name {
  margin-right: 10px;
  span {
    font-weight: bold;
  }
}
.button-wrapper {
  margin: 0px 10px;
  button {
    padding: 5px 10px;
  }
}
</style>
